"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneCellulareUtenteDtoToJSON = exports.CertificazioneCellulareUtenteDtoFromJSONTyped = exports.CertificazioneCellulareUtenteDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function CertificazioneCellulareUtenteDtoFromJSON(json) {
    return CertificazioneCellulareUtenteDtoFromJSONTyped(json, false);
}
exports.CertificazioneCellulareUtenteDtoFromJSON = CertificazioneCellulareUtenteDtoFromJSON;
function CertificazioneCellulareUtenteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cellulareCertificazione': !runtime_1.exists(json, 'cellulareCertificazione') ? undefined : json['cellulareCertificazione'],
        'isInviata': !runtime_1.exists(json, 'isInviata') ? undefined : json['isInviata'],
    };
}
exports.CertificazioneCellulareUtenteDtoFromJSONTyped = CertificazioneCellulareUtenteDtoFromJSONTyped;
function CertificazioneCellulareUtenteDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cellulareCertificazione': value.cellulareCertificazione,
        'isInviata': value.isInviata,
    };
}
exports.CertificazioneCellulareUtenteDtoToJSON = CertificazioneCellulareUtenteDtoToJSON;
